<template>
  <div :class="classes">
    <input type="checkbox" :id="props.id" :checked="modelValue" @change="updateValue" :disabled="disabled" />
    <span class="checkmark" aria-hidden="true"></span>
    <label class="text lang_translate" :for="props.id">{{ props.label }}</label>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

const props = defineProps({
  id: String,
  label: String,
  modelValue: Boolean,
  disabled: Boolean,
  smallPrint: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:modelValue']);

const updateValue = (event: Event) => {
  const newValue = (event.target as HTMLInputElement).checked;
  emit('update:modelValue', newValue);
};

const classes = computed(() => ({
  checkbox: true,
  'small-print': props.smallPrint,
  disabled: props.disabled,
}));
</script>

<style lang="scss" scoped>
.checkbox {
  display: block;
  position: relative;
  margin-bottom: 12px;
  font-size: 18px;
  font-family: 'english-grotesque', sans-serif;
  font-weight: 300;
  user-select: none;

  &.disabled {
    opacity: 0.4;

    label {
      cursor: not-allowed;
    }
  }

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
    z-index: 2;
  }

  label {
    display: block;
    width: 100%;
    padding-left: 30px;
    cursor: pointer;
    z-index: 5;
    text-align: left;
    z-index: 4;
    &:before {
      content: '';
      position: absolute;
      left: 0;
      width: 30px;
      height: 100%;
      z-index: 3;
    }
  }

  .checkmark {
    position: absolute;
    top: 50%;
    left: 0;
    height: 16px;
    width: 16px;
    transform: translateY(-50%);
    border-radius: 4px;
    background-color: rgb(var(--v-theme-white));
    border: 2px solid rgb(var(--v-theme-grey-300));
    z-index: 1;
  }

  &:not(.disabled):has(~ label:hover) {
    border-color: rgb(var(--v-theme-highlight));
  }

  input:checked ~ .checkmark {
    border-color: rgb(var(--v-theme-secondary));
    background-color: rgb(var(--v-theme-secondary));
  }

  .checkmark:after {
    content: '';
    position: absolute;
    display: none;
  }

  input:checked ~ .checkmark:after {
    display: block;
    position: absolute;
  }

  .checkmark:after {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(45deg);
    margin-top: -1px;
    width: 6px;
    height: 12px;
    border: solid rgb(var(--v-theme-primary));
    border-width: 0 3px 3px 0;
  }

  &.small-print {
    label {
      font-size: 12px;
      line-height: 12px;

      @media screen and (min-width: ($mobile-screen + 1px)) {
        font-size: 14px;
        line-height: 14px;
      }
    }
  }
}
</style>
